// import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Header.css";
import axios from "axios";

const Header = () => {
    const [mobileMenuVisible, setMobileMenuVisible] = useState(false);
    const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const location = useLocation();
    const { pathname } = location;

    const modalRef = useRef(null);
    const modalInstance = useRef(null);

    useEffect(() => {
        if (window.bootstrap && modalRef.current) {
            modalInstance.current = new window.bootstrap.Modal(modalRef.current);
        }
    }, []);

    const openModal = () => {
        if (modalInstance.current) {
            modalInstance.current.show();
        }
    };

    const closeModal = () => {
        if (modalInstance.current) {
            modalInstance.current.hide();
        }
    };

    useEffect(() => {
        const mainSection = document.querySelector('.home-mainsection');
        const mainSectionBottom = mainSection ? mainSection.offsetTop + mainSection.offsetHeight : null;

        const handleScroll = () => {
            if (mainSectionBottom) {
                // Show white background when scrolling past main section
                const shouldBeSticky = window.scrollY >= mainSectionBottom - 700; // Start showing 100px before reaching the bottom
                setIsSticky(shouldBeSticky);
            } else {
                // Fallback: show background after 100px scroll
                const shouldBeSticky = window.scrollY > 10;
                setIsSticky(shouldBeSticky);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Call on mount

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [pathname]);

    // Handle mobile menu toggle
    const handleMobileToggle = () => {
        setMobileMenuVisible(!mobileMenuVisible);
        scrollToTop();
    };

    // Handle close menu
    const handleCloseMenu = () => {
        setMobileMenuVisible(false);
        setMobileServicesOpen(false);
    };

    // Handle menu link click
    const handleMenuLinkClick = () => {
        setMobileMenuVisible(false);
    };

    // Add/remove mobile-menu-visible class on body and prevent/allow scroll
    useEffect(() => {
        if (mobileMenuVisible) {
            document.body.classList.add('mobile-menu-visible');
            document.body.style.overflow = 'hidden';
        } else {
            document.body.classList.remove('mobile-menu-visible');
            document.body.style.overflowY = 'auto';
            document.body.style.overflowX = 'hidden';
        }

        return () => {
            document.body.classList.remove('mobile-menu-visible');
            document.body.style.overflowY = 'auto';
            document.body.style.overflowX = 'hidden';
        };
    }, [mobileMenuVisible]);

    // Close menu on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && mobileMenuVisible) {
                setMobileMenuVisible(false);
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [mobileMenuVisible]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };


    // api call
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        // location: "",
        serviceName: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);

    // Handle Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Submit Form
    const submitMessage = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}services`, // 👈 endpoint
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // ✅ Clear form after success
            setFormData({
                name: "",
                email: "",
                mobile: "",
                // location: "",
                serviceName: "",
                message: "",
            });

        } catch (error) {
            console.error("Error:", error);
            // alert("Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <style>
                {`
                    @keyframes slideDown {
                        0% {
                            transform: translateY(-100%);
                            opacity: 0;
                        }
                        100% {
                            transform: translateY(0);
                            opacity: 1;
                        }
                    }
                    
                    .main-header .header {
                        background: ${isSticky ? '#ffffff' : 'transparent'};
                        transition: background 0.3s ease;
                    }

                    /* Nav links and button text color: white when not sticky, #252628 when sticky */
                    .main-header .navigation li a,
                    .main-header .navigation li a:visited,
                    .main-header .header-right .btn-one,
                    .main-header .header-right .btn-one .txt,
                    .main-header .nav-outer .btn-one,
                    .main-header .nav-outer .btn-one .txt {
                        color: ${isSticky ? '#252628' : '#ffffff'} !important;
                    }

                    /* Active / hover / selected color */
                    .main-header .navigation li.current a,
                    .main-header .navigation li a:hover,
                    .main-header .navigation li a:active,
                    .main-header .header-right .btn-one:hover,
                    .main-header .nav-outer .btn-one:hover {
                        color: #FD6D0A !important;
                    }

                    /* Mobile menu links
                       keep the same color behaviour so mobile menu matches header state */
                    .mobile-menu .navigation li a {
                        color: ${isSticky ? '#252628' : '#ffffff'} !important;
                    }
                    .mobile-menu .navigation li.current a,
                    .mobile-menu .navigation li a:hover {
                        color: #FD6D0A !important;
                    }
                `}
            </style>
            {/* Main header*/}
            <header
                className={`main-header header-style-one ${isSticky ? "fixed-header" : ""}`}
                style={{
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    zIndex: '9999',
                    backgroundColor: isSticky ? '#ffffff' : 'transparent',
                    boxShadow: isSticky ? '0 0 10px rgba(0,0,0,0.1)' : 'none',
                    transition: 'all 0.3s ease'
                }}
            >
                {/*Start Header*/}
                <div className="header">
                    <div className="auto-container">
                        <div className="outer-box">
                            <div className="header-left">
                                <div className="logo">
                                    <NavLink to="/"><img className="headerlogo" src="/assets/images/logo.svg" alt="Awesome Logo" title /></NavLink>
                                </div>
                            </div>
                            <div className="header-middle">
                                <div className="nav-outer style1 clearfix">
                                    {/*Mobile Navigation Toggler*/}
                                    <div
                                        className="mobile-nav-toggler"
                                        onClick={handleMobileToggle}
                                        role="button"
                                        tabIndex={0}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                handleMobileToggle();
                                            }
                                        }}
                                    >
                                        <div className="inner">
                                            <span className="icon-bar" />
                                            <span className="icon-bar" />
                                            <span className="icon-bar" />
                                        </div>
                                    </div>
                                    {/* Main Menu */}
                                    <nav className="main-menu style1 navbar-expand-md navbar-light">
                                        <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                            <ul className="navigation clearfix">
                                                <li className={pathname === "/" ? "current" : ""} ><NavLink to="/">Home</NavLink></li>
                                                <li className={pathname === "/About-Us" ? "current" : ""}><NavLink to="/About-Us">About us</NavLink></li>
                                                {/* <li className={pathname === "/Services" ? "current" : ""}><NavLink to="/Services">Services</NavLink></li> */}
                                                {/* <li className="dropdown"><a href="#">Services</a>
                                                    <ul>
                                                        <li><NavLink to="/ArchitectureDesign">Architecture Design</NavLink></li>
                                                        <li><NavLink to="/BuildingConstruction">Building Construction</NavLink></li>
                                                        <li><NavLink to="/LayoutPlanning">Layout Planning</NavLink></li>
                                                        <li><NavLink to="/TDRConsultancy">TDR Consultancy</NavLink></li>
                                                        <li><NavLink to="/GovernmentSchemes">Government Schemes</NavLink></li>
                                                    </ul>
                                                </li> */}

                                                <li className={pathname === "/Architecture" ? "current" : ""}><NavLink to="/Architecture">Architecture</NavLink></li>
                                                <li className={pathname === "/Building" ? "current" : ""}><NavLink to="/Building">Building</NavLink></li>
                                                <li className={pathname === "/Layout" ? "current" : ""}><NavLink to="/Layout">Layouts</NavLink></li>
                                                <li className={pathname === "/TDR" ? "current" : ""}><NavLink to="/TDR">TDR</NavLink></li>
                                                <li className={pathname === "/BPS" ? "current" : ""}><NavLink to="/BPS">BPS</NavLink></li>
                                                <li className={pathname === "/LRS" ? "current" : ""}><NavLink to="/LRS">LRS</NavLink></li>

                                                <li className={pathname === "/Contact-Us" ? "current" : ""}><NavLink to="/Contact-Us">Contact</NavLink></li>
                                            </ul>
                                        </div>
                                    </nav>
                                    {/* Main Menu End*/}
                                </div>
                            </div>
                            <div className="header-right">
                                <div className="header-right_buttom">
                                    {/* <div className="btns-box">
                                        <button
                                            type="button"
                                            className="btn-one btn-one222"
                                            onClick={openModal}
                                        >
                                            <span className="txt">BOOK SLOT</span>
                                        </button>
                                    </div> */}
                                    <button type="button" className="custmbtn" onClick={openModal}>
                                        <p>BOOK SLOT</p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*End header*/}

                
                {/* Mobile Menu */}
                <div className={`mobile-menu ${mobileMenuVisible ? "mobile-menu-visible" : ""}`}>
                    <div className="menu-backdrop" onClick={handleCloseMenu} />
                    <div className="close-btn" onClick={handleCloseMenu}>
                        <span className="icon fa fa-times-circle" />
                    </div>

                    <nav className="menu-box">
                        <div className="nav-logo">
                            <NavLink to="/" onClick={handleMenuLinkClick}>
                                <img src="/assets/images/logo.svg" alt="Logo" />
                            </NavLink>
                        </div>

                        <ul className="navigation clearfix">
                            <li className={pathname === "/" ? "current" : ""}>
                                <NavLink to="/" onClick={handleMenuLinkClick}>Home</NavLink>
                            </li>

                            <li className={pathname === "/About-Us" ? "current" : ""}>
                                <NavLink to="/About-Us" onClick={handleMenuLinkClick}>About us</NavLink>
                            </li>

                            {/* Mobile Services Dropdown */}
                            {/* <li className={`dropdown ${mobileServicesOpen ? "open" : ""}`}>
                                <NavLink
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMobileServicesOpen(!mobileServicesOpen);
                                    }}
                                >
                                    Services
                                </NavLink>
                                <div
                                    className="dropdown-btn"
                                    onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
                                >
                                    <i className={`fa ${mobileServicesOpen ? "fa-minus" : "fa-plus"}`} />
                                </div>

                                {mobileServicesOpen && (
                                    <ul style={{ display: "block" }}>
                                        <li><NavLink to="/ArchitectureDesign" onClick={handleMenuLinkClick}>Architecture Design</NavLink></li>
                                        <li><NavLink to="/BuildingConstruction" onClick={handleMenuLinkClick}>Building Construction</NavLink></li>
                                        <li><NavLink to="/LayoutPlanning" onClick={handleMenuLinkClick}>Layout Planning</NavLink></li>
                                        <li><NavLink to="/TDRConsultancy" onClick={handleMenuLinkClick}>TDR Consultancy</NavLink></li>
                                        <li><NavLink to="/GovernmentSchemes" onClick={handleMenuLinkClick}>Government Schemes</NavLink></li>
                                    </ul>
                                )}
                            </li> */}
                            <li className={pathname === "/Architecture" ? "current" : ""}>
                                <NavLink to="/Architecture" onClick={handleMenuLinkClick}>Architecture</NavLink>
                            </li>
                            <li className={pathname === "/Building" ? "current" : ""}>
                                <NavLink to="/Building" onClick={handleMenuLinkClick}>Building</NavLink>
                            </li>
                            <li className={pathname === "/Layout" ? "current" : ""}>
                                <NavLink to="/Layout" onClick={handleMenuLinkClick}>Layout</NavLink>
                            </li>
                            <li className={pathname === "/TDR" ? "current" : ""}>
                                <NavLink to="/TDR" onClick={handleMenuLinkClick}>TDR</NavLink>
                            </li>
                            <li className={pathname === "/BPS" ? "current" : ""}>
                                <NavLink to="/BPS" onClick={handleMenuLinkClick}>BPS</NavLink>
                            </li>
                            <li className={pathname === "/LRS" ? "current" : ""}>
                                <NavLink to="/LRS" onClick={handleMenuLinkClick}>LRS</NavLink>
                            </li>
                           

                            <li className={pathname === "/Contact-Us" ? "current" : ""}>
                                <NavLink to="/Contact-Us" onClick={handleMenuLinkClick}>Contact</NavLink>
                            </li>
                        </ul>
                    </nav>
                </div>
                {/* End Mobile Menu */}
            </header>

            <div>
                {/* Modal */}
                <div className="modal fade" style={{ position: 'absolute', zIndex: 999999 }} ref={modalRef} id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Book Slot</h5>
                                {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" /> */}
                                <button type="button" onClick={closeModal} className="btn btn-secondary" data-bs-dismiss="modal">X</button>
                            </div>
                            <div className="modal-body">
                                <div className='contactus-section2Right'>
                                    <div className="col-md-12">
                                        <form onSubmit={submitMessage}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p className="input-inp-head">Full Name *</p>

                                                    <input
                                                        type="text"
                                                        name="name"   // ✅ FIXED
                                                        placeholder="Full Name"
                                                        required
                                                        className="input-inp"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="input-inp-head">Email Address *</p>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        placeholder="Email Address"
                                                        required
                                                        className="input-inp"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mt-1">
                                                <div className="col-md-6">
                                                    <p className="input-inp-head">Phone Number *</p>
                                                    <input
                                                        type="tel"
                                                        name="mobile"   // ✅ FIXED
                                                        placeholder="Phone Number"
                                                        required
                                                        className="input-inp"
                                                        value={formData.mobile}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="input-inp-head">Select Service</p>
                                                    <div >
                                                        <select
                                                            name="serviceName"   // ✅ FIXED
                                                            required
                                                            className="input-inp"
                                                            value={formData.serviceName}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select Service</option>
                                                            <option value="Architecture Planning">Architecture</option>
                                                            <option value="Building">Building</option>
                                                            <option value="Layouts">Layout</option>
                                                            <option value="TDR">TDR</option>
                                                            <option value="BPS">BPS</option>
                                                            <option value="LRS">LRS</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <p className="input-inp-head">Address</p>
                                                    <textarea
                                                        name="message"
                                                        placeholder="Type your Address"
                                                        required
                                                        rows="8"
                                                        className="input-inp input-inp2"
                                                        value={formData.message}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="text-center">
                                            <button type="submit" className="home-section5box-bt">
                                                <p className="home-section5-btHead">Send Message</p>
                                            </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Header;